export function Logo({ className = "w-16 h-16", color = "#afbb8b" }) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 512 512" 
      className={className}
      aria-label="MealPlan Genie Logo"
    >
      <path fill={color} d="
  M 289.90 216.33
  C 284.77 216.76 287.02 209.50 287.85 206.08
  A 4.63 4.40 52.3 0 0 287.96 205.00
  Q 287.82 196.65 283.44 191.50
  Q 278.03 185.11 273.83 181.92
  C 267.23 176.88 262.03 173.76 258.66 167.60
  Q 255.72 162.22 254.90 153.45
  A 7.64 7.49 48.3 0 1 255.00 151.33
  Q 256.02 145.99 256.66 143.16
  Q 259.92 128.59 271.88 119.89
  C 273.32 118.85 277.09 116.77 278.82 118.16
  C 281.19 120.06 278.64 124.69 277.91 126.93
  A 6.58 6.56 55.2 0 0 277.61 128.61
  Q 277.49 130.83 277.33 138.49
  Q 277.23 143.29 278.81 146.35
  Q 281.47 151.49 285.27 154.49
  Q 291.14 159.12 299.23 166.44
  Q 308.50 174.83 307.89 187.99
  Q 307.51 196.33 304.67 201.98
  C 302.16 206.97 297.69 210.99 293.32 214.89
  Q 291.91 216.16 289.90 216.33
  Z"/>
      <path fill={color} d="
  M 275.62 227.42
  Q 273.64 228.13 271.83 228.11
  Q 266.21 228.02 256.84 228.39
  C 252.92 228.55 248.08 228.22 245.51 227.82
  C 241.59 227.23 242.71 222.05 242.75 218.63
  C 242.84 212.01 246.48 207.64 252.90 205.64
  C 258.31 203.96 263.12 203.02 268.47 204.73
  C 275.56 206.99 276.98 208.77 278.45 215.95
  A 6.40 6.37 -46.1 0 1 278.49 218.30
  L 277.32 225.39
  A 2.60 2.59 85.0 0 1 275.62 227.42
  Z"/>
      <path fill={color} d="
  M 166.56 266.54
  L 171.30 266.08
  A 1.48 1.27 30.9 0 0 171.59 266.03
  Q 187.83 261.40 201.88 252.12
  C 207.15 248.63 213.10 245.18 219.29 241.78
  Q 228.14 236.93 239.69 233.83
  Q 244.57 232.53 249.94 232.58
  Q 259.74 232.69 280.42 232.68
  A 4.20 4.07 -31.6 0 1 282.18 233.07
  Q 294.50 238.99 309.86 247.13
  Q 315.68 250.22 323.74 253.03
  Q 341.32 259.14 358.81 251.57
  Q 372.15 245.79 378.88 241.92
  Q 382.69 239.72 395.37 234.89
  Q 403.33 231.86 416.20 231.43
  Q 422.73 231.21 428.14 232.86
  C 433.43 234.49 442.43 237.78 442.63 244.00
  C 442.80 249.56 439.54 250.40 434.42 251.06
  Q 423.10 252.53 416.69 255.44
  Q 404.21 261.11 393.39 273.17
  Q 384.08 283.54 361.85 311.59
  Q 354.67 320.64 341.46 331.42
  Q 327.23 343.04 309.91 349.42
  C 303.68 351.71 298.32 352.69 291.25 354.36
  A 11.54 11.44 36.7 0 1 289.12 354.66
  Q 285.89 354.79 282.68 355.67
  A 6.51 6.42 -51.7 0 1 280.83 355.90
  C 274.15 355.80 268.16 356.50 260.88 356.56
  Q 257.94 356.59 252.65 356.16
  Q 250.30 355.98 243.40 355.93
  A 8.44 8.36 -37.5 0 1 241.49 355.69
  C 237.84 354.78 233.80 354.67 229.71 353.84
  C 209.25 349.71 191.25 340.76 176.17 326.45
  Q 167.96 318.66 162.54 311.07
  A 1.62 1.62 0.0 0 0 161.10 310.40
  C 156.48 310.76 152.11 309.64 148.17 309.38
  Q 138.73 308.75 124.22 305.08
  C 107.66 300.88 92.29 293.85 80.98 281.03
  Q 65.78 263.78 69.24 241.05
  C 71.56 225.75 82.33 215.43 97.01 211.51
  Q 116.71 206.26 134.59 217.77
  Q 143.76 223.67 149.35 232.51
  Q 155.49 242.22 158.64 250.13
  Q 162.20 259.09 165.18 265.74
  A 1.38 1.37 -14.6 0 0 166.56 266.54
  Z
  M 145.79 288.43
  Q 145.94 287.64 145.66 286.87
  Q 142.37 277.59 136.31 262.93
  Q 132.17 252.90 127.66 245.65
  C 123.68 239.23 120.36 235.99 113.49 233.09
  A 5.68 5.62 56.4 0 0 111.26 232.63
  Q 107.11 232.63 106.73 232.60
  C 101.29 232.23 96.75 235.67 94.34 240.36
  C 91.65 245.60 90.96 251.32 93.14 257.22
  C 101.09 278.68 125.19 284.78 145.45 288.65
  A 0.29 0.29 0.0 0 0 145.79 288.43
  Z"/>
      <path fill={color} d="
  M 320.35 380.13
  C 321.82 386.36 317.88 387.98 312.77 387.99
  Q 234.83 388.16 210.25 388.12
  Q 206.55 388.11 203.42 387.44
  A 2.05 2.04 -17.0 0 1 202.40 386.90
  Q 199.57 384.14 201.12 380.59
  C 202.03 378.50 204.66 377.12 207.18 376.23
  Q 214.06 373.78 217.54 371.04
  Q 218.74 370.10 225.09 363.60
  Q 226.55 362.10 229.77 362.01
  Q 236.78 361.81 243.11 362.49
  Q 250.90 363.33 256.42 363.30
  C 261.95 363.27 274.53 363.86 283.73 362.34
  Q 289.33 361.42 294.50 363.32
  A 4.48 4.40 75.3 0 1 295.94 364.18
  Q 297.16 365.26 299.79 367.96
  C 304.14 372.43 310.82 375.33 316.66 376.75
  Q 317.55 376.97 319.84 379.23
  A 1.94 1.93 15.6 0 1 320.35 380.13
  Z"/>
    </svg>
  );
}